<!--
 @description 应用交付-新建应用交付
 @author xiehan
 @date 2018/10/17
-->
<template>
  <div class="addAppDelivery__content">
    <g-back :history="history"></g-back>
    <div>
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="80px">
        <el-form-item :label="$t('appDelivery.appGroup')" prop="group">
          <el-select v-model="addForm.group" @change="groupChange">
            <el-option v-for="(item, key) in select_group" :label="item" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('appDelivery.appName')" prop="appName">
          <el-select v-model="addForm.appName">
            <el-option v-for="(item, key) in select_app" :label="item" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('appDelivery.programPackage')" prop="packageName">
          <span class="choose-btn" v-text="addForm.packageName" @click="openPackageDialog"></span>
        </el-form-item>
        <el-form-item :label="$t('appDelivery.cluster')" prop="clusterName">
          <span class="choose-btn" v-text="addForm.clusterName" @click="openClusterDialog"></span>
        </el-form-item>
        <el-form-item>
            <el-button type="primary"
              @click="save"
              v-g-rac="gRac('addAppDelivery@create')" 
              v-text="$t('common.confirm')"></el-button>
            <el-button type="primary"
              @click="cancel"
              class="ml-base"
              v-text="$t('common.cancel')"></el-button>
        </el-form-item>
      </el-form>
      <el-dialog :closeOnClickModal="false" 
        :title="dialogInputTitle" 
        :visible.sync="dialogVisible" 
        width="800px"
        custom-class="delivery-dialog">
          <el-form ref="searchDialogForm" :model="searchDialogForm" :inline="true" label-width="0" input-width="auto">
            <el-form-item prop="dialogInput">
              <el-input v-model="searchDialogForm.dialogInput" :placeholder="dialogInputTitle"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" 
                @click="searchDialogTable"
                v-text="$t('common.search')"></el-button>
            </el-form-item>
          </el-form>
          <el-table-extend
            :data="dialogTableData"
            :head="dialogTableHead"
            :currentChange="dTableCurrentChange"
            :sizeChange="dTableSizeChange"
            highlight-current-row
            :rowClick="dTableClick"
            border>
          </el-table-extend>
        <div slot="footer">
          <el-button @click="dialogVisible = false" v-text="$t('common.cancel')"></el-button>
          <el-button type="primary" @click="dialogConfirm" v-text="$t('common.confirm')"></el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import appDeliveryBiz from '@/logic/continuousDelivery/appDeliveryBiz'
  import programPackageManageBiz from '@/logic/continuousDelivery/programPackageManageBiz'
  import ClusterManagerBiz from '@/logic/continuousDelivery/clusterManagerBiz'
  export default {
    mixins: [rac, dic],
    data () {
      let checkPackage = (rule, value, callback) => {
        if (!value || value === this.$t('common.chooseTips')) {
          return callback(new Error(this.$t('common.chooseTips') + this.$t('appDelivery.programPackage')))
        } else {
          callback()
        }
      }
      let checkCluster = (rule, value, callback) => {
        if (!value || value === this.$t('common.chooseTips')) {
          return callback(new Error(this.$t('common.chooseTips') + this.$t('appDelivery.cluster')))
        } else {
          callback()
        }
      }
      return {
        history: [],
        addRules: {
          group: [
            { required: true, message: this.$t('common.chooseTips') + this.$t('appDelivery.appGroup'), trigger: 'blur' }
          ],
          appName: [
            { required: true, message: this.$t('common.chooseTips') + this.$t('appDelivery.appName'), trigger: 'blur' }
          ],
          packageName: [
            { required: true, validator: checkPackage, trigger: 'blur' }
          ],
          clusterName: [
            { required: true, validator: checkCluster, trigger: 'blur' }
          ]
        },
        addForm: {
          group: '',
          appName: '',
          packageName: this.$t('common.chooseTips'),
          clusterName: this.$t('common.chooseTips'),
          version: '',
          envType: ''
        },
        select_group: {},
        select_app: {},
        select_envType: {},
        packageTableVisible: false,
        clusterTableVisible: false,
        dialogVisible: false,
        dialogTableData: {},
        dialogTableHead: [],
        packageCurrentPage: 1,
        packagePerPageCount: 10,
        clusterCurrentPage: 1,
        clusterPerPageCount: 10,
        dialogInputTitle: '',
        searchDialogForm: {
          dialogInput: ''
        },
        clickRowObj: {}
      }
    },
    components: {},
    methods: {
      setHistory () {
        this.history = []
        this.history.push({ name: this.$t('appDelivery.addDelivery') })
      },
      async waitEnvType () {
        await this.dGetDictionaryByCode('envType')
        this.select_envType = { ...this.dDictionary.envType }
      },
      async waitNewGroup () {
        await this.dGetGroup()
        this.select_group = { ...this.dDictionaryGroup }
      },
      async waitGroup () {
        await this.dGetGroup()
        this.select_group = { ...this.dDictionaryGroup }
        this.addForm.group = Object.keys(this.select_group)[0]
        this.waitApp(this.addForm.group)
      },
      async waitApp (group) {
        await this.dGetAppByGroup('', group)
        this.select_app = { ...this.dDictionaryApp[group] }
        this.addForm.appName = Object.keys(this.select_app)[0]
      },
      setDefaultGroup () {
        this.addForm.group = Object.keys(this.select_group)[0]
        this.waitApp(this.addForm.group)
      },
      groupChange (val) {
        this.waitNewGroup()
        this.waitApp(val)
      },
      save () {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            appDeliveryBiz.saveAppDelivery({ ...this.addForm }).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'appDelivery' })
            })
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.push({ name: 'appDelivery' })
      },
      resetForm () {
        this.$refs.addForm.resetFields()
      },
      openPackageDialog () {
        this.searchDialogForm.dialogInput = ''
        this.packageTableVisible = true
        this.clusterTableVisible = false
        this.dialogInputTitle = this.$t('appDelivery.programPackage')
        this.searchPackage()
      },
      openClusterDialog () {
        this.searchDialogForm.dialogInput = ''
        this.packageTableVisible = false
        this.clusterTableVisible = true
        this.dialogInputTitle = this.$t('appDelivery.cluster')
        this.searchCluster()
      },
      searchPackage () {
        let searchObj = {
          currentPage: this.packageCurrentPage,
          perPageCount: this.packagePerPageCount,
          appName: this.addForm.appName
        }
        if (this.searchDialogForm.dialogInput) searchObj.packageName = this.searchDialogForm.dialogInput
        programPackageManageBiz.findRelease(searchObj).then((data) => {
          if (data) this.dialogTableData = data
          this.dialogTableHead = [
            { key: 'appPackage', label: this.$t('appDelivery.table.appPackage'), showOverflowTooltip: true },
            { key: 'version', label: this.$t('appDelivery.table.version'), showOverflowTooltip: true },
            { key: 'instanceName', label: this.$t('appDelivery.table.instanceName'), showOverflowTooltip: true },
            { key: 'creator', label: this.$t('appDelivery.table.creator'), showOverflowTooltip: true }
          ]
          this.dialogVisible = true
        })
      },
      searchCluster () {
        let searchObj = {
          currentPage: this.clusterCurrentPage,
          perPageCount: this.clusterPerPageCount
        }
        if (this.searchDialogForm.dialogInput) searchObj.clusterName = this.searchDialogForm.dialogInput
        ClusterManagerBiz.getCluster(searchObj).then((data) => {
          if (data) this.dialogTableData = data
          this.dialogTableHead = [
            { key: 'clusterName', label: this.$t('clusterManager.table.clusterName'), showOverflowTooltip: true },
            { key: 'envType',
              label: this.$t('clusterManager.table.envType'),
              showOverflowTooltip: true,
              formatter: 'Dictionary',
              formatterDic: this.select_envType },
            { key: 'operator', label: this.$t('clusterManager.table.operator'), showOverflowTooltip: true },
            { key: 'remarks', label: this.$t('clusterManager.table.remarks'), showOverflowTooltip: true }
          ]
          this.dialogVisible = true
        })
      },
      searchDialogTable (fromClick = false) {
        if (fromClick) {
          this.packageCurrentPage = 1
          this.packagePerPageCount = 10
          this.clusterCurrentPage = 1
          this.clusterPerPageCount = 10
        }
        if (this.packageTableVisible) {
          this.searchPackage()
        } else if (this.clusterTableVisible) {
          this.searchCluster()
        }
      },
      dTableCurrentChange (val) {
        if (this.packageTableVisible) {
          this.packageCurrentPage = val
          this.searchPackage()
        } else if (this.clusterTableVisible) {
          this.clusterCurrentPage = val
          this.searchCluster()
        }
      },
      dTableSizeChange (val) {
        if (this.packageTableVisible) {
          this.packageCurrentPage = 1
          this.packagePerPageCount = val
          this.searchPackage()
        } else if (this.clusterTableVisible) {
          this.clusterCurrentPage = 1
          this.clusterPerPageCount = val
          this.searchCluster()
        }
      },
      dTableClick (row) {
        this.clickRowObj = row
      },
      dialogConfirm () {
        if (!(this.clickRowObj && Object.keys(this.clickRowObj).length > 0)) {
          this.$message({
            message: this.$t('appDelivery.selectTips'),
            type: 'warning'
          })
          return
        }
        if (this.packageTableVisible) {
          this.addForm.packageName = this.clickRowObj.appPackage
          this.addForm.version = this.clickRowObj.version
        } else if (this.clusterTableVisible) {
          this.addForm.clusterName = this.clickRowObj.clusterName
          this.addForm.envType = Object.keys(this.select_envType).filter(item => this.clickRowObj.envType === this.select_envType[item])[0]
        }
        this.dialogVisible = false
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'addAppDelivery' && from.name === 'appDelivery') {
          this.resetForm()
          this.waitGroup()
          this.waitEnvType()
        }
      }
    },
    mounted () {
      this.setHistory()
      this.waitGroup()
      this.waitEnvType()
    }
  }
</script>

<style scoped>
  .choose-btn {
    color: #0B8DE5;
    cursor: pointer;
  }
  .delivery-dialog .el-form-item {
    margin-bottom: 0;
  }
</style>